import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { MARK_CHAT_AS_READ } from '../queries/mutations';

export function useMarkChatAsRead() {
  // The mutation returns { uuid, hasUnreadMessages, activeStreamId }; the
  // cache normalizes Chat entities by uuid, so the sidebar rows and badge
  // update from the response itself — no refetch needed.
  const [markChatAsReadMutation] = useMutation(MARK_CHAT_AS_READ);

  const markChatAsRead = useCallback(
    async (chatUuid: string) => {
      try {
        await markChatAsReadMutation({
          variables: { chatUuid },
        });
      } catch (error) {
        // Silently handle errors as this is not a critical operation; the
        // level-triggered evaluator retries on a later chats emission.
      }
    },
    [markChatAsReadMutation],
  );

  return markChatAsRead;
}
